import { render, staticRenderFns } from "./EcosystemsListModal.vue?vue&type=template&id=6c628808&scoped=true&"
import script from "./EcosystemsListModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./EcosystemsListModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c628808",
  null
  
)

export default component.exports